import { User } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { UserActionsRowDialog } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/UserActionsRowDialog';
import { UserTableRow } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserTableRow';
import { UserListTableProps } from '@/components/shared/components/UserList/types/TableProps';
import { UserRowActionType } from '@/components/shared/components/UserList/types/UserRowActionType';
import { useDialog } from '@/components/shared/hooks/useDialog';

interface UserTableBodyProps extends UserListTableProps {
  users: User[];
  editModeAllowed: boolean;
  userId?: string;
}

export const UserTableBody = ({ users, userId, editModeAllowed, tableProps }: UserTableBodyProps) => {
  const { opened, toggleDialog, setOpened } = useDialog();

  const [selectedUser, setSelectedUser] = useState<User | undefined>();
  const [rowUserAction, setRowUserAction] = useState<UserRowActionType | undefined>();

  const handleRowUserAction = ({ user, userAction }: { user: User; userAction: UserRowActionType }) => {
    setSelectedUser(user);
    setRowUserAction(userAction);
    toggleDialog();
  };

  return (
    <>
      {users
        .sort((a, b) => (a.createdAt.getTime() > b.createdAt.getTime() ? 1 : -1))
        .map((user, i) => (
          <UserTableRow
            key={i}
            user={user}
            editModeAllowed={editModeAllowed}
            handleRowUserAction={handleRowUserAction}
            tableProps={tableProps}
          />
        ))}
      {selectedUser && rowUserAction && (
        <UserActionsRowDialog
          userId={userId ?? selectedUser.id}
          selectedUser={selectedUser}
          userAction={rowUserAction}
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
        />
      )}
    </>
  );
};
